<script setup>
defineProps({
  message: {
    type: String,
  },
});
</script>

<template>
  <div v-show="message">
    <p
      class="text-sm text-red-600 bg-red-50 border border-red-200 rounded px-2 py-1"
      role="alert"
    >
      <svg
        class="inline w-4 h-4 mr-1 text-red-500"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M12 9v2m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
      {{ message }}
    </p>
  </div>
</template>
